import React from 'react';

export default function Skeleton({ height, width, circle, rootClass }) {
    return (
        <div className={`${height} ${width} bg-dark-gray ${circle ? 'rounded-full' : 'rounded-lg'} animate-pulse ${rootClass}`}></div>
    )
}